module.exports = __webpack_public_path__ + "img/1478801137.061ffb37.jpg";